import React, { useState } from "react";
import Accounts from "./partials/Accounts";
import { useDispatch } from "react-redux";
import { setActiveAccount } from "../../redux/actions/home/ActiveAccountAction";
import { SearchIcons } from "../Icons";

const OtherAccounts = ({ clientAccounts, activeAccount }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const handleActiveAccount = async (account) => {
    await dispatch(setActiveAccount(account));
  };

  const otherAvailableAccounts = clientAccounts.filter(
    (acc) => acc.id !== activeAccount?.id,
  );

  const filteredAccounts = otherAvailableAccounts.filter(
    (acc) =>
      acc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      acc.account_number.includes(searchTerm),
  );

  return (
    <div className="flex flex-col h-full">
      <h3 className="other-accounts-lable flex justify-between items-center">
        Other accounts
      </h3>
      {otherAvailableAccounts.length > 0 ? (
        <>
          {otherAvailableAccounts.length > 3 && (
            <div className="search-input-wrapper flex items-center px-4 py-2 rounded-xl mb-4 border border-divider">
              <SearchIcons className="w-4 h-4 text-text-secondary mr-2" />
              <input
                type="text"
                placeholder="Search your accounts..."
                className="search-input"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          )}

          <div className="space-y-3 overflow-y-auto max-h-[400px] pr-2 custom-scrollbar">
            {filteredAccounts.length > 0 ? (
              filteredAccounts.map((account) => (
                <div
                  key={account.id}
                  onClick={() => handleActiveAccount(account)}
                  className="relative cursor-pointer"
                >
                  <Accounts account={account} />
                </div>
              ))
            ) : (
              <p className="text-center text-text-secondary text-xs py-10">
                No accounts match "{searchTerm}"
              </p>
            )}
          </div>
        </>
      ) : (
        <p className="text-text-secondary text-xs py-4 italic">
          No other accounts found.
        </p>
      )}
    </div>
  );
};

export default OtherAccounts;
